import React from 'react'
import { Box, Typography } from '@mui/material'
import { AgendamentoContext } from '../../../contexts/AgendamentoContext'
import { BiCalendarCheck, BiCalendarHeart, BiCalendarX } from 'react-icons/bi'
import { FaAngleRight } from 'react-icons/fa6'
import { InputButton } from '../../Simple'
import { CalClock } from '../../../assets'
import RouterHook from '../../../contexts/RouterHook'
import moment from 'moment'

import './stylesDP.css'
import { Services } from '../../../services'

const btt_HoraFixa = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '5px 5px 0px 5px',
  fontSize: '16px',
  borderTop: 'var(--border-mid) solid var(--color-border-gray)',
  borderRadius: '0px',
  marginTop: '3px',
}

export default function MobileAgendamento() {
  const serverRouter = RouterHook()
  const { sttCtxAgend } = React.useContext(AgendamentoContext)

  return (
    <Box className='contain-details-pedido'>
      {ReturnFalta(sttCtxAgend.pedido)}
      <Typography variant='h5' sx={{ fontWeight: 'bold' }}>{`${Services.ReturnHoraMin(
        new Date(sttCtxAgend.pedido.dataInicio),
      )} às ${Services.ReturnHoraMin(new Date(sttCtxAgend.pedido.dataFinal))}`}</Typography>
      <Typography>
        {moment(sttCtxAgend.pedido.dataInicio).format('dddd, DD/MM/YYYY')[0].toUpperCase() +
          moment(sttCtxAgend.pedido.dataInicio).format('dddd, DD/MM/YYYY').slice(1)}
      </Typography>
      {sttCtxAgend.pedido.categoriaEsporte !== null && (
        <Box className='contain-categoria-esporte'>
          <img
            className='img-categoria-esporte'
            src={`${sttCtxAgend.pedido.categoriaEsporte.urlFoto}${sttCtxAgend.pedido.categoriaEsporte.foto}`}
            alt='Categoria Esporte'
          />
          <h3 className='text-categoria-esporte'>{sttCtxAgend.pedido.categoriaEsporte.descricao}</h3>
        </Box>
      )}
      {sttCtxAgend.pedido.mensalista_idmensalista !== null && (
        <InputButton
          fullWidth
          variant='text'
          sx={btt_HoraFixa}
          endIcon={<FaAngleRight size={20} />}
          onClick={() => {
            serverRouter('mensalista', sttCtxAgend.pedido.mensalista_idmensalista)
          }}
        >
          Horário Fixo
        </InputButton>
      )}
    </Box>
  )

  function ReturnFalta(pedido) {
    let falta = moment(pedido.dataInicio).startOf('minute').fromNow().toUpperCase()
    switch (pedido.status) {
      case 'SOLICITADO':
        return (
          <div className='contain-detalhes-falta-pedido'>
            <div className='contain-detalhes-row'>
              <img
                src={CalClock}
                className='icon-pedido-status'
                color={'#ff7043'}
                style={{ color: '#ff7043', width: '25px', height: '25px' }}
                alt=''
              />
              <h3 style={{ color: '#ff7043' }}>{pedido.status}</h3>
            </div>
            <h3 style={{ color: '#ff7043' }} className={'text-states-detalhes-pedido'}>
              {falta}
            </h3>
          </div>
        )
      case 'AGENDADO':
        return (
          <div className='contain-detalhes-falta-pedido'>
            <div className='contain-detalhes-row'>
              <BiCalendarHeart className='icon-pedido-status' color={'#24ad49'} />
              <h3 style={{ color: '#24ad49' }}>{pedido.status}</h3>
            </div>
            <h3 style={{ color: '#24ad49' }} className={'text-states-detalhes-pedido'}>
              {falta}
            </h3>
          </div>
        )
      case 'CANCELADO':
        return (
          <div className='contain-detalhes-falta-pedido'>
            <div className='contain-detalhes-row'>
              <BiCalendarX size={25} className='icon-pedido-status' color={'#bf3324'} />
              <h3 style={{ color: '#bf3324' }}>{pedido.status}</h3>
            </div>
          </div>
        )
      case 'REALIZADO':
        falta = moment(pedido.dataFinal).startOf('minute').fromNow().toUpperCase()
        return (
          <div className='contain-detalhes-falta-pedido'>
            <div className='contain-detalhes-row'>
              <BiCalendarCheck size={25} className='icon-pedido-status' color={'#00cda4'} />
              <h3 style={{ color: '#00cda4' }}>{pedido.status}</h3>
            </div>
            <h3 style={{ color: '#00cda4' }} className={'text-states-detalhes-pedido'}>
              {falta}
            </h3>
          </div>
        )
      default:
        return <></>
    }
  }
}
